// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'heart-rate';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.544 4.295a4.037 4.037 0 0 0-6.435-1.032L9 4.275 7.89 3.263a4.037 4.037 0 0 0-6.434 1.034 3.952 3.952 0 0 0 .753 4.594L9 15.906l6.791-7.017a3.951 3.951 0 0 0 .753-4.594z' />
    <path d='M4.219 7.937h1.96a.266.266 0 0 1 .238.147l1.256 2.512a.266.266 0 0 0 .484-.02l1.686-4.215a.266.266 0 0 1 .484-.02l.727 1.45a.267.267 0 0 0 .238.146h2.49' />
  </g>
);

export const viewBox = '0 0 18 18';
